module.exports = __webpack_public_path__ + "img/header_logo.9c7c5b4e.png";